import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleAccessories } from '@/mocks/articles';

export default function AccessoriesGuidePage() {
  return <ArticleLayout article={articleAccessories} />;
}